/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import useEventData from '@bottlebooks/gatsby-theme-event/src/components/SiteSearch/useEventData';
import { EditIcon } from '@bottlebooks/gatsby-theme-base/src';
import { useLocation } from '@reach/router';
export default function EditProductInBottlebooksAction({ product, ...rest }) {
  const { collection } = useEventData();

  const registrationId = product.registrationId;
  if (!registrationId) return null;
  const location = useLocation();

  return (
    <a
      href={`https://registrations.bottlebooks.me/de/${
        collection.workspaceId || '5a5385acfef95b36d5add5b8'
      }/collections/${
        collection.collectionId
      }/registrations/${registrationId}/products/${
        product.productId
      }/edit?from=${location.href}`}
      // @ts-ignore It's ok here to keep the referrer - it's our platform after all.
      target="_blank"
      title="Edit in Bottlebooks"
      onClick={(e) => e.stopPropagation()}
      {...rest}
    >
      <EditIcon size="xsmall" />
    </a>
  );
}
